import type * as Types from 'app/types/graphql';

import { VariantUrlSelectFragmentDoc } from '../fragments/variantUrl.generated';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type VariantUrlCreateMutationVariables = Types.Exact<{
  input: Types.CreateVariantUrlInput;
}>;

export type VariantUrlCreateMutationResponse = {
  variantURLCreate?: Types.Maybe<
    Pick<Types.VariantUrl, 'id' | 'baseID' | 'handle' | 'title' | 'redirectURL' | 'resourceType'>
  >;
};

export const VariantUrlCreateDocument = `
    mutation VariantURLCreate($input: CreateVariantURLInput!) {
  variantURLCreate(input: $input) {
    ...VariantURLSelect
  }
}
    ${VariantUrlSelectFragmentDoc}`;

export const useVariantUrlCreateMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    VariantUrlCreateMutationResponse,
    TError,
    VariantUrlCreateMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    VariantUrlCreateMutationResponse,
    TError,
    VariantUrlCreateMutationVariables,
    TContext
  >(
    ['VariantURLCreate'],
    (variables?: VariantUrlCreateMutationVariables) =>
      appFetcher<VariantUrlCreateMutationResponse, VariantUrlCreateMutationVariables>(
        VariantUrlCreateDocument,
        variables,
      )(),
    options,
  );
};

useVariantUrlCreateMutation.getKey = () => ['VariantURLCreate'];
